import React, { useEffect } from 'react';
import {
  Await,
  Link,
  useLoaderData,
} from '@tanstack/react-router';

import { loadUserProfile } from '../api/Auth';

import Loading from '../components/Loading';

import { getUserProfile } from '../helpers/auth';

interface EmailChangeConfirmationResult {
  status: number;
  data?: {
    message?: string;
    email?: string;
  };
}

const EmailChangeConfirmationResultView: React.FC<{ result: EmailChangeConfirmationResult }> = ({ result }) => {
  const isConfirmed = result?.status === 200;
  const isLoggedIn = Boolean(getUserProfile()?.id);

  useEffect(() => {
    if (isConfirmed && isLoggedIn) {
      loadUserProfile();
    }
  }, [isConfirmed, isLoggedIn]);

  if (isConfirmed) {
    return (
      <div className="wa-stack wa-gap-md">
        <h3 className="page-title center">
          Email changed!
        </h3>
        <p className="center">
          Your email address is now <strong>{result.data?.email}</strong>.
        </p>
        <p className="center">
          {isLoggedIn ? (
            <Link to="/account">Go to your account</Link>
          ) : (
            <>You can now <Link to="/login">log in</Link> with your new email address.</>
          )}
        </p>
      </div>
    );
  }

  return (
    <div className="wa-stack wa-gap-md">
      <h3 className="page-title center">
        Email change failed!
      </h3>
      <p className="center">
        {result?.data?.message || 'This confirmation link is invalid or has expired.'}
      </p>
      <p className="center">
        {isLoggedIn ? (
          <Link to="/account/email">Request a new confirmation link</Link>
        ) : (
          <><Link to="/login">Log in</Link> to request a new confirmation link.</>
        )}
      </p>
      <p className="center">
        If the problem persists, please contact support at <a href="mailto:Grace@lgcystory.com">Grace@lgcystory.com</a>
      </p>
    </div>
  );
};

const EmailChangeConfirmation: React.FC = () => {
  const { confirmationResult } = useLoaderData({ strict: false });

  return (
    <div className="container email-confirmation-container">
      <Await promise={confirmationResult} fallback={<Loading />}>
        {(result: EmailChangeConfirmationResult) => <EmailChangeConfirmationResultView result={result} />}
      </Await>
    </div>
  );
}

export default EmailChangeConfirmation;
